/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsUserControllerCreateMutationRequest,
  TelegramTransactionsUserControllerCreateMutationResponse,
  TelegramTransactionsUserControllerCreate401,
} from '../types/TelegramTransactionsUserControllerCreate.ts';

function getTelegramTransactionsUserCreateUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/transactions` as const };
  return res;
}

/**
 * {@link /api/user/telegram/transactions}
 */
export async function telegramTransactionsUserCreate(
  data: TelegramTransactionsUserControllerCreateMutationRequest,
  config: Partial<RequestConfig<TelegramTransactionsUserControllerCreateMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramTransactionsUserControllerCreateMutationResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerCreate401>,
    TelegramTransactionsUserControllerCreateMutationRequest
  >({
    method: 'POST',
    url: getTelegramTransactionsUserCreateUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
